var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('stripe-checkout',{ref:"stripeIntegration",attrs:{"pk":_vm.publishableKey,"session-id":_vm.userStripeSessionId},on:{"loading":function (v) { return (_vm.loading = v); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }